import {Directive, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {PageLayoutService} from '../../../../../../../services/menu/page-layout.service';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[menuAction]',
})
export class MenuActionDirective implements OnInit, OnDestroy {
  private _caption: string;
  @Output() action = new EventEmitter();

  @Input() set caption(value: string) {
    if (value != this._caption) {
      this._caption = value;
      this.pageLayoutService.updateMenu();
    }
  }
  @Input() enabled: boolean;

  get caption() {
    return this._caption;
  }
  constructor(private pageLayoutService: PageLayoutService) {}

  ngOnInit() {
    this.pageLayoutService.addMenuAction(this);
  }
  ngOnDestroy() {
    this.pageLayoutService.removeMenuAction(this);
  }
}
